import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";
// eslint-disable-next-line max-len
import { useAttendanceVersionsMobile } from "./attendanceVersionsMobile/useAttendanceVersionsMobile";
import { translate } from "@/config/translator";
import { Version } from "@/api/openapi";
import { formatDateFromLang } from "@/config/utils";
import Skeleton from "react-loading-skeleton";
import TextButton from "@/components/textButton/TextButton";
import ConfirmationDialog from "@/components/confirmationDialog/ConfirmationDialog";
import { clsx } from "clsx/lite";

export function AttendanceVersionsMobile() {
  const {
    navigate,
    lang,
    attendanceVersions,
    onRestoreVersion,
    restoreVersionConfirmationOpen,
    openRestoreVersionConfirmation,
    closeRestoreVersionConfirmation,
    confirmationOpenVersion,
  } = useAttendanceVersionsMobile();

  return (
    <>
      <TopBarMobile
        onBack={() => navigate(-1)}
        headerString={translate("attendances", lang)}
      />
      <div className="p-6 flex flex-col gap-8">
        <div className="font-medium text-xl">
          {translate("versionHistory", lang)}
        </div>
        <div className="flex flex-col gap-4">
          {(attendanceVersions ?? Array.from({ length: 20 })).map(
            (version: Version | undefined, index, { length }) => (
              <>
                <div className="flex flex-row justify-between">
                  {version ? (
                    <div className="flex flex-row items-center gap-3">
                      <div>
                        {formatDateFromLang(new Date(version.timestamp), lang)}
                      </div>
                      {version.draft && (
                        <div
                          className={clsx(
                            "px-1.5",
                            "py-0.5",
                            "rounded-md",
                            "bg-primary-50",
                            "flex",
                            "justify-center",
                            "items-center",
                            "font-medium",
                            "text-primary",
                          )}
                        >
                          {translate("draft", lang)}
                        </div>
                      )}
                    </div>
                  ) : (
                    <Skeleton />
                  )}
                  <TextButton
                    onClick={() =>
                      version ? openRestoreVersionConfirmation(version) : {}
                    }
                  >
                    {translate("restore", lang)}
                  </TextButton>
                </div>
                {index !== length - 1 && <div className="h-px bg-neutral" />}
              </>
            ),
          )}
        </div>
      </div>
      <ConfirmationDialog
        titleString={translate("areYouSure", lang)}
        messageString={translate("restoreVersionConfirmationMessage", lang, {
          "{date}": confirmationOpenVersion
            ? formatDateFromLang(
                new Date(confirmationOpenVersion.timestamp),
                lang,
              )
            : "",
        })}
        isOpen={restoreVersionConfirmationOpen}
        onCancel={closeRestoreVersionConfirmation}
        onConfirm={onRestoreVersion}
      />
    </>
  );
}
